// @ts-nocheck
export const localeCodes =  [
  "en",
  "de",
  "fr",
  "it"
]
export const localeLoaders = {
  en: [],
  de: [],
  fr: [],
  it: []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en",
    _hreflang: "en",
    _sitemap: "en"
  },
  {
    code: "de",
    name: "Deutsch",
    language: "de",
    _hreflang: "de",
    _sitemap: "de"
  },
  {
    code: "fr",
    name: "Français",
    language: "fr",
    _hreflang: "fr",
    _sitemap: "fr"
  },
  {
    code: "it",
    name: "Italiano",
    language: "it",
    _hreflang: "it",
    _sitemap: "it"
  }
]
/** client **/

/** client-end **/